import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";

function CancelButton({ path }) {
  const navigate = useNavigate();

  const handleCancel = (e) => {
    e.preventDefault();
    navigate(path);
  };

  return (
    <Button
      onClick={handleCancel}
      variant="contained"
      color="error"
      sx={{
        backgroundColor: "#F04B25",
        color: "#fff",
        "&:hover": { backgroundColor: "#c43718" },
      }}
    >
      Cancel
    </Button>
  );
}

export default CancelButton;
